
import React, { useReducer, useEffect } from 'react';
import TokenContext from './TokenContext';
import TokenReducer from './TokenReducer';
import {GET_TOKEN, ACTIVE_TOKEN, REDIRECT_LOGIN} from '../type';
import clienteAxios from '../../Utils/axios';

const TokenState = props =>{
    const initialState = {
        token: "",
        active_token: "",
        redirect_login: false
    };

    const [state,dispatch] = useReducer(TokenReducer, initialState);


    const Get_Token_F = token => {
        dispatch({
            type: GET_TOKEN,
            payload: token
        })
    }

    const Active_Token_F = active => {
        dispatch({
            type: ACTIVE_TOKEN,
            payload: active
        })
    }

    const Redirect_F = redirect => {
        dispatch({
            type: REDIRECT_LOGIN,
            payload: redirect
        })
    }
    
    useEffect(() => {
        const GetDataUser = async () =>{
            try {
                const dataForm = new FormData();
                dataForm.append('sesionid',state.active_token);

                const res = await clienteAxios.post('/LoginValidateMDD/', dataForm);

                Get_Token_F(res.data.access)
                Redirect_F(true)

                localStorage.setItem('token', res.data.access);
                localStorage.setItem('refresh', res.data.refresh);

            } catch (error) {
                console.log(error)
                window.location.href = process.env.REACT_APP_URL;
            }
        }
        
        if(state.active_token !== "" && state.active_token !== null){
            GetDataUser()
        }
        
        if( ( !state.active_token && !state.token ) && (window.location.pathname !== "/" && window.location.pathname !== "/validacion" && window.location.pathname !== "/validacion2/" && window.location.pathname !== "/validacion2") ){
            window.location.href = '/';
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state.active_token])
    
    return (
        <TokenContext.Provider 
            value = {{
                token: state.token,
                redirect_login: state.redirect_login,
                active_token: state.active_token,
                Get_Token_F,
                Active_Token_F,
                Redirect_F,
            }}
        >
            { props.children }
        </TokenContext.Provider>
    )
};

export default TokenState